import React, { useEffect, useMemo, useState } from 'react';
import './CardsCantidad.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faBook, faImage, faAddressBook, faTachometerAlt, faCode, faClipboardList, faHandHoldingDollar } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor, useLocation } from "react-router-dom";
import baseURL from '../../url';
import moneda from '../../moneda';
import ventasService from '../../../services/ventasService';

export default function CardsCantidad() {
  const location = useLocation();

  const [productos, setProductos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [banners, setBanners] = useState([]);
  const [categorias, setCategoras] = useState([]);
  const [contactos, setContactos] = useState([]);
  const [codigos, setCodigos] = useState([]);

  // ---- Pedidos (usar el MISMO endpoint que PedidosData) ----
  const [pedidos, setPedidos] = useState([]);
  const [estadisticas, setEstadisticas] = useState({});
  const [paginacion, setPaginacion] = useState({});

  // ---- Ventas gestionadas ----
  const [ventasStats, setVentasStats] = useState({});

  useEffect(() => {
    cargarProductos();
    cargarUsuarios();
    cargarBanners();
    cargarCategoria();
    cargarContacto();
    cargarCodigos();
    cargarPedidosDashboard();
    cargarVentas();
  }, []);

  const cargarVentas = async () => {
    const data = await ventasService.listar({});
    setVentasStats(data.error ? {} : (data.estadisticas || {}));
  };

  const cargarProductos = () => {
    fetch(`${baseURL}/productosGet.php`).then(r=>r.json()).then(d=>setProductos(d.productos||[])).catch(()=>{});
  };
  const cargarUsuarios = () => {
    fetch(`${baseURL}/usuariosGet.php`).then(r=>r.json()).then(d=>setUsuarios(d.usuarios||[])).catch(()=>{});
  };
  const cargarBanners = () => {
    fetch(`${baseURL}/bannersGet.php`).then(r=>r.json()).then(d=>setBanners(d.banner||[])).catch(()=>{});
  };
  const cargarCategoria = () => {
    fetch(`${baseURL}/categoriasGet.php`).then(r=>r.json()).then(d=>setCategoras(d.categorias||[])).catch(()=>{});
  };
  const cargarContacto = () => {
    fetch(`${baseURL}/contactoGet.php`).then(r=>r.json()).then(d=>setContactos(d.contacto||[])).catch(()=>{});
  };
  const cargarCodigos = () => {
    fetch(`${baseURL}/codigosGet.php`).then(r=>r.json()).then(d=>setCodigos(d.codigos||[])).catch(()=>{});
  };

  // IMPORTANTE: mismo endpoint que PedidosData → pedidoGet.php
  // Subo el límite para que el conteo de productos por pedidos sea representativo.
  const cargarPedidosDashboard = async () => {
    const params = new URLSearchParams({
      include_items: 'true',   // así podemos sumar unidades también
      limite: '100',
      offset: '0'
    });
    try {
      const res = await fetch(`${baseURL}/pedidoGet.php?${params}`);
      const data = await res.json();
      setPedidos(Array.isArray(data.pedidos) ? data.pedidos : []);
      setEstadisticas(data.estadisticas || {});
      setPaginacion(data.paginacion || {});
    } catch (e) {
      // opcional: manejar error/toast
    }
  };

  // Productos en los pedidos (cantidad de líneas ítem)
  const productosEnPedidos = useMemo(() => {
    // si la API incluyó total_items, úsalo; si no, items.length
    return pedidos.reduce((acc, p) => {
      const n = (typeof p.total_items === 'number')
        ? p.total_items
        : Array.isArray(p.items) ? p.items.length : 0;
      return acc + n;
    }, 0);
  }, [pedidos]);

  // Unidades totales (sumar cantidades) — requiere include_items=true
  const unidadesEnPedidos = useMemo(() => {
    return pedidos.reduce((acc, p) => {
      const items = Array.isArray(p.items) ? p.items : [];
      const unidades = items.reduce((a, it) => a + Number(it.cantidad || 0), 0);
      return acc + unidades;
    }, 0);
  }, [pedidos]);

  return (
    <div className='CardsCantidad'>
      <Anchor to={`/dashboard/usuarios`} className={location.pathname === '/dashboard/usuarios' ? 'activeLink cardCantidad' : 'cardCantidad'}>
        <FontAwesomeIcon icon={faUser} className='icons' />
        <div className='deColumn'>
          <h3>Usuarios</h3>
          <h2>{usuarios.length}</h2>
        </div>
      </Anchor>

      <Anchor to={`/dashboard/productos`} className={location.pathname === '/dashboard/productos' ? 'activeLink cardCantidad' : 'cardCantidad'}>
        <FontAwesomeIcon icon={faBook} className='icons' />
        <div className='deColumn'>
          <h3>Productos</h3>
          <h2>{productos.length}</h2>
        </div>
      </Anchor>

      {/* >>> AQUÍ van ahora los datos de productos relacionados a pedidos <<< */}
      <Anchor to={`/dashboard/pedidos`} className={location.pathname === '/dashboard/pedidos' ? 'activeLink cardCantidad' : 'cardCantidad'}>
        <FontAwesomeIcon icon={faClipboardList} className='icons' />
        <div className='deColumn'>
          <h3>Pedidos</h3>
          <h2>{estadisticas?.total_pedidos ?? (paginacion?.total_registros ?? 0)}</h2>

          {/* Subestadísticas tomadas de los pedidos cargados (hasta 'limite') */}
          <div className="deColumn">
            <h3>Unidades: <strong>{unidadesEnPedidos}</strong></h3>
          </div>
        </div>
      </Anchor>

      <Anchor to={`/dashboard/ventas`} className={location.pathname === '/dashboard/ventas' ? 'activeLink cardCantidad' : 'cardCantidad'}>
        <FontAwesomeIcon icon={faHandHoldingDollar} className='icons' />
        <div className='deColumn'>
          <h3>Ventas</h3>
          <h2>{ventasStats?.total_ventas ?? 0}</h2>

          <div className="deColumn">
            <h3>Pendientes: <strong>{ventasStats?.pendientes ?? 0}</strong></h3>
            <h3>Por cobrar: <strong>{moneda} {Number(ventasStats?.saldo_por_cobrar || 0).toLocaleString('es-CO')}</strong></h3>
          </div>
        </div>
      </Anchor>

      <Anchor to={`/dashboard/banners`} className={location.pathname === '/dashboard/banners' ? 'activeLink cardCantidad' : 'cardCantidad'}>
        <FontAwesomeIcon icon={faImage} className='icons' />
        <div className='deColumn'>
          <h3>Banners</h3>
          <h2>{banners.length}</h2>
        </div>
      </Anchor>

      <Anchor to={`/dashboard/categorias`} className={location.pathname === '/dashboard/categorias' ? 'activeLink cardCantidad' : 'cardCantidad'}>
        <FontAwesomeIcon icon={faTachometerAlt} className='icons' />
        <div className='deColumn'>
          <h3>Categorías</h3>
          <h2>{categorias.length}</h2>
        </div>
      </Anchor>

      <Anchor to={`/dashboard/contacto`} className={location.pathname === '/dashboard/contacto' ? 'activeLink cardCantidad' : 'cardCantidad'}>
        <FontAwesomeIcon icon={faAddressBook} className='icons' />
        <div className='deColumn'>
          <h3>Contactos</h3>
          <h2>{contactos.length}</h2>
        </div>
      </Anchor>

      <Anchor to={`/dashboard/codigos`} className={location.pathname === '/dashboard/codigos' ? 'activeLink cardCantidad' : 'cardCantidad'}>
        <FontAwesomeIcon icon={faCode} className='icons' />
        <div className='deColumn'>
          <h3>Códigos</h3>
          <h2>{codigos.length}</h2>
        </div>
      </Anchor>
    </div>
  );
}
